import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bulk-register-result-modal-content" }
const _hoisted_2 = { class: "counts" }
const _hoisted_3 = { class: "counts__item" }
const _hoisted_4 = { class: "counts__item__label" }
const _hoisted_5 = { class: "counts__item__value" }
const _hoisted_6 = { class: "counts__item__label" }
const _hoisted_7 = { class: "counts__item" }
const _hoisted_8 = { class: "counts__item__label" }
const _hoisted_9 = { class: "counts__item__value" }
const _hoisted_10 = { class: "counts__item__label" }
const _hoisted_11 = { class: "table__container" }
const _hoisted_12 = { class: "error-reason" }
const _hoisted_13 = { class: "order-status" }

import { i18n } from '@/i18n';
import { BulkRegisterResult } from '../domains/entities/UnmatchedOrderItem';
import { computed, ref } from 'vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { TABLE_HEADERS } from '../constants';
import { useUnmatchedOrderStore } from '../pages/useUnmatchedOrderStore';
import { storeToRefs } from 'pinia';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkRegisterResultModalContent',
  props: {
    result: {}
  },
  setup(__props: any) {

const t = i18n.t;

const store = useUnmatchedOrderStore();
const { state } = storeToRefs(store);
const props = __props;

const isDisplayDetailTable = ref(false);

const displayHeaders = computed(() => [
  { key: 'rejectReason', label: '除外理由', width: '400px', type: 'uni' },
  ...TABLE_HEADERS.slice(1, -2),
]);
const displayItems = computed(() =>
  state.value.items.filter((i) =>
    Object.entries(props.result.rejectedUnmatchedOrders)
      .flatMap(([_, v]) => v)
      .includes(i.unmatchedOrderId)
  )
);
const registerRejectedCount = computed(() =>
  Object.entries(props.result.rejectedUnmatchedOrders).reduce((acc, [_, cur]) => (acc += cur.length), 0)
);

/**
 * IDから失敗理由を取得する
 * @param targetId - 調べるunmatchedOrderId
 */
const getRejectReason = (targetId: string) => {
  const res = Object.entries(props.result.rejectedUnmatchedOrders).find(([_, arr]) => arr?.includes(targetId))?.[0];
  return res ? t(res) : '--';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('登録済:')), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(props.result.registeredCount), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('件')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('除外:')), 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(registerRejectedCount.value), 1),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('件')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "table__label",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isDisplayDetailTable.value = !isDisplayDetailTable.value))
      }, [
        _createTextVNode(_toDisplayString(_unref(t)('除外した未照合発注の詳細')) + " ", 1),
        _createVNode(Mdi, { icon: "expand_more" })
      ]),
      _withDirectives(_createVNode(EzTable, {
        "grid-template-columns": displayHeaders.value.map((h) => h.width),
        "sticky-header": "",
        "max-height": "calc(100vh - 600px)"
      }, {
        header: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayHeaders.value, (header) => {
            return (_openBlock(), _createBlock(EzHeader, {
              key: `header:${header.key}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(header.label)), 1)
              ], undefined, true),
              _: 2
            }, 1024))
          }), 128))
        ]),
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayItems.value, (item, index) => {
            return (_openBlock(), _createBlock(EzTableRow, {
              key: item.unmatchedOrderId,
              "grid-template-columns": displayHeaders.value.map((h) => h.width),
              class: "unmatched-row"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayHeaders.value, (header) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `row:${header.key}:${index}`
                  }, [
                    (header.key === 'rejectReason')
                      ? (_openBlock(), _createBlock(EzCell, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(getRejectReason(item.unmatchedOrderId)), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024))
                      : (header.key === 'orderStatus')
                        ? (_openBlock(), _createBlock(EzCell, {
                            key: 1,
                            "force-center": ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, [
                                _createVNode(OrderStatusBadge, {
                                  "order-status-str": item.orderStatus
                                }, null, 8, ["order-status-str"])
                              ])
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        : (header.type === 'num')
                          ? (_openBlock(), _createBlock(EzCell, {
                              key: 2,
                              "is-number": ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item[header.key]?.toLocaleString() ?? ''), 1)
                              ], undefined, true),
                              _: 2
                            }, 1024))
                          : (header.type === 'date')
                            ? (_openBlock(), _createBlock(EzCell, {
                                key: 3,
                                "is-number": ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item[header.key] ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(item[header.key]) : ''), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            : (header.type === 'str')
                              ? (_openBlock(), _createBlock(EzCell, {
                                  key: 4,
                                  "is-number": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item[header.key] ?? ''), 1)
                                  ], undefined, true),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], undefined, true),
              _: 2
            }, 1032, ["grid-template-columns"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["grid-template-columns"]), [
        [_vShow, isDisplayDetailTable.value]
      ])
    ])
  ]))
}
}

})